module.exports = __webpack_public_path__ + "static/media/apple-logo.c4f222c5.svg";